var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.0703125 12.832C0.0703125 16.3594 1.08985 20.25 2.81251 23.2734C3.10548 23.7773 3.65626 23.918 4.1836 23.625C4.67579 23.3555 4.81641 22.8047 4.51173 22.2539C2.94141 19.3945 2.06251 15.9844 2.06251 12.832C2.06251 6.32812 6.03516 1.99219 12 1.99219C17.9531 1.99219 21.9375 6.32812 21.9375 12.832C21.9375 15.9844 21.0469 19.3945 19.4765 22.2539C19.1719 22.8047 19.3125 23.3555 19.8047 23.625C20.332 23.918 20.8945 23.7773 21.1758 23.2734C22.8984 20.25 23.9297 16.3594 23.9297 12.832C23.9297 5.12109 19.1719 0 12 0C4.81641 0 0.0703125 5.12109 0.0703125 12.832ZM3.73829 22.9805C4.12501 24.3281 5.27344 24.9493 6.63282 24.5626C7.98048 24.1758 8.61329 23.0039 8.21485 21.6562L6.53907 15.9375C6.15235 14.6016 5.00391 13.9688 3.64454 14.3555C2.29688 14.7539 1.66407 15.9141 2.06251 17.2734L3.73829 22.9805ZM20.25 22.9805L21.9258 17.2734C22.3242 15.9023 21.7031 14.7539 20.3437 14.3555C18.9844 13.9688 17.8476 14.6016 17.4492 15.9375L15.7734 21.6562C15.375 23.0157 16.0078 24.1758 17.3555 24.5626C18.7265 24.9493 19.8633 24.3281 20.25 22.9805Z",
    fill: "#6E7987"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.765e41a32f2b8af744ab9af6c6337b85.svg";
export { ForwardRef as ReactComponent };